<div class="tpl3pl-page-container">
	<div class="tpl3pl-toolbar">
		<div class="tpl3pl-toolbar-filters">
			<mat-form-field appearance="fill" class="tpl3pl-field mr-2">
				<mat-label>Status</mat-label>
				<mat-select [(ngModel)]="statusFilter" (selectionChange)="onStatusChange()">
					<mat-option value="">All</mat-option>
					<mat-option value="pending">Pending</mat-option>
					<mat-option value="exporting">Exporting</mat-option>
					<mat-option value="exported">Exported</mat-option>
					<mat-option value="failed">Failed</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field appearance="fill" class="tpl3pl-field mr-2">
				<mat-label>Order search</mat-label>
				<input
					matInput
					[(ngModel)]="orderFilter"
					(ngModelChange)="applyOrderFilter()"
					(keyup.enter)="applyOrderFilter()"
					placeholder="Filter by order number">
				<span matSuffix>
					<button mat-icon-button (click)="applyOrderFilter()">
						<mat-icon>search</mat-icon>
					</button>
				</span>
			</mat-form-field>
			<mat-checkbox [(ngModel)]="includeArchived" (ngModelChange)="loadQueue()" class="tpl3pl-toolbar-checkbox">Include archived</mat-checkbox>
			<span class="tpl3pl-queue-cap text-muted small ml-2" *ngIf="!loading && queueTotal != null">Showing up to 100 items</span>
			<span class="tpl3pl-queue-total text-muted small ml-2" *ngIf="!loading && queueTotal != null && queueTotal > 100">({{ queueTotal }} total in queue)</span>
		</div>
		<div class="tpl3pl-toolbar-actions">
			<button
				mat-stroked-button
				(click)="refreshQueue()"
				[disabled]="loading"
				matTooltip="Reload queue">
				<mat-spinner *ngIf="loading" diameter="20" class="d-inline-block mr-1"></mat-spinner>
				<mat-icon *ngIf="!loading">refresh</mat-icon>
				<span class="ml-1">{{ loading ? 'Loading…' : 'Refresh' }}</span>
			</button>
			<button
				mat-raised-button
				color="primary"
				(click)="processQueue()"
				[disabled]="processing || loading || rawPushInProgress || !dataSource?.data?.length"
				matTooltip="Process pending orders in the queue">
				<mat-spinner *ngIf="processing" diameter="20" class="d-inline-block mr-1"></mat-spinner>
				<mat-icon *ngIf="!processing">play_arrow</mat-icon>
				<span class="ml-1">{{ processing ? 'Processing…' : 'Process Queue' }}</span>
			</button>
			<ng-container *ngIf="eligibleOrdersCount > 0">
				<mat-form-field appearance="fill" class="tpl3pl-field mr-2 raw-push-limit">
					<mat-label>Batch size</mat-label>
					<mat-select [(ngModel)]="rawPushLimit" (ngModelChange)="onRawPushLimitChange()">
						<mat-option [value]="5">5</mat-option>
						<mat-option [value]="10">10</mat-option>
						<mat-option [value]="20">20</mat-option>
					</mat-select>
				</mat-form-field>
				<button
					mat-stroked-button
					(click)="rawManualPush()"
					[disabled]="loading || rawPushInProgress || eligibleOrdersCount === 0"
					matTooltip="Push this many pending/failed orders one at a time and see each API response">
					<mat-spinner *ngIf="rawPushInProgress" diameter="20" class="d-inline-block mr-1"></mat-spinner>
					<mat-icon *ngIf="!rawPushInProgress">code</mat-icon>
					<span class="ml-1">{{ rawPushInProgress ? ('Pushing ' + rawPushProgress + '…') : 'Raw manual push' }}</span>
				</button>
			</ng-container>
			<button
				mat-stroked-button
				(click)="archiveAllExported()"
				class="mr-2"
				[disabled]="loading || processing || rawPushInProgress"
				matTooltip="Archive all exported orders (hide from default list)">
				<mat-icon>archive</mat-icon>
				<span class="ml-1">Archive Exported</span>
			</button>
		</div>
	</div>

	<div *ngIf="rawPushInProgress && rawPushProgress" class="mt-2 small text-muted">
		Pushing order ({{ rawPushProgress }})…
	</div>

	<div *ngIf="rawPushResults.length > 0" class="mt-3 raw-push-results-panel">
		<div class="d-flex justify-content-between align-items-center mb-2">
			<strong>Raw manual push results ({{ rawPushResults.length }} orders)</strong>
			<button mat-stroked-button (click)="dismissRawPushResults()">Dismiss</button>
		</div>
		<table mat-table [dataSource]="rawPushResultsDataSource" class="w-100 compact-table">
			<ng-container matColumnDef="orderno">
				<th mat-header-cell *matHeaderCellDef>Order</th>
				<td mat-cell *matCellDef="let row">{{ row.orderno }}</td>
			</ng-container>
			<ng-container matColumnDef="status">
				<th mat-header-cell *matHeaderCellDef>Status</th>
				<td mat-cell *matCellDef="let row">
					<span [class.badge-success]="row.success" [class.badge-danger]="!row.success" class="badge">{{ row.success ? 'Success' : 'Failed' }}</span>
				</td>
			</ng-container>
			<ng-container matColumnDef="message">
				<th mat-header-cell *matHeaderCellDef>Message</th>
				<td mat-cell *matCellDef="let row" class="message-cell">{{ row.message || '–' }}</td>
			</ng-container>
			<ng-container matColumnDef="view_raw">
				<th mat-header-cell *matHeaderCellDef></th>
				<td mat-cell *matCellDef="let row">
					<button mat-icon-button color="accent" (click)="openRawResponseForResult(row)" matTooltip="View raw response">
						<mat-icon>code</mat-icon>
					</button>
				</td>
			</ng-container>
			<tr mat-header-row *matHeaderRowDef="rawPushResultsColumns"></tr>
			<tr mat-row *matRowDef="let r; columns: rawPushResultsColumns;"></tr>
		</table>
	</div>

	<div *ngIf="lastExportResult && lastExportResult.success" class="mt-3 result-banner">
		<div class="alert alert-success d-flex justify-content-between align-items-center">
			<div><strong>Export:</strong> {{ lastExportResult.message }}</div>
			<button type="button" class="close" aria-label="Close" (click)="dismissLastResult()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
	</div>

	<div class="table-responsive position-relative tpl3pl-table-wrapper">
		<div *ngIf="loading" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="mt-2 mb-0">Loading orders…</p>
		</div>
		<div *ngIf="processing && !loading" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="mt-2 mb-0">Processing queue…</p>
		</div>
		<table mat-table [dataSource]="dataSource" class="w-100" matSort [class.tpl3pl-loading-opacity]="loading || processing">
			<ng-container matColumnDef="orderno">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Order Number</th>
				<td mat-cell *matCellDef="let item">
					<span class="order-link" (click)="viewOrder(item.orderno)">{{ item.orderno }}</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="tpl3pl_remote_order_id">
				<th mat-header-cell *matHeaderCellDef matTooltip="3PL/PGS order ID from their system">3PL Order ID</th>
				<td mat-cell *matCellDef="let item">
					<span *ngIf="item.tpl3pl_remote_order_id" class="text-monospace">{{ item.tpl3pl_remote_order_id }}</span>
					<span *ngIf="!item.tpl3pl_remote_order_id" class="text-muted">—</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="export_status">
				<th mat-header-cell *matHeaderCellDef mat-sort-header class="status-header-cell">Status</th>
				<td mat-cell *matCellDef="let item" class="status-column-cell">
					<div class="status-cell">
						<span [ngClass]="getStatusBadgeClass(item.export_status)" class="badge">
							{{ getStatusLabel(item.export_status) }}
						</span>
						<span *ngIf="item.archived_at" class="badge badge-secondary ml-1">Archived</span>
						<span *ngIf="item.export_status === 'exported' && item.exported_at" class="status-completed">{{ item.exported_at | date:'short' }}</span>
					</div>
				</td>
			</ng-container>

			<ng-container matColumnDef="created_at">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Recorded</th>
				<td mat-cell *matCellDef="let item">{{ item.created_at | date:'short' }}</td>
			</ng-container>

			<ng-container matColumnDef="export_attempts">
				<th mat-header-cell *matHeaderCellDef>Attempts</th>
				<td mat-cell *matCellDef="let item">{{ item.export_attempts }}</td>
			</ng-container>

			<ng-container matColumnDef="last_export_attempt">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Last attempt</th>
				<td mat-cell *matCellDef="let item">{{ item.last_export_attempt | date:'short' }}</td>
			</ng-container>

			<ng-container matColumnDef="error_message">
				<th mat-header-cell *matHeaderCellDef>Error</th>
				<td mat-cell *matCellDef="let item" class="error-cell">
					<span
						*ngIf="(item.error_message || item.export_response?.circuit_open) && item.export_status !== 'exported'"
						class="error-summary"
						(click)="openErrorDetails(item)"
						[attr.title]="item.error_message || 'View details'">
						{{ getErrorSummary(item) }}
					</span>
					<span *ngIf="(!item.error_message && !item.export_response?.circuit_open) || item.export_status === 'exported'" class="text-muted">—</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="actions">
				<th mat-header-cell *matHeaderCellDef>Actions</th>
				<td mat-cell *matCellDef="let item">
					<div class="actions-cell">
						<mat-spinner *ngIf="exportingOrderNo === item.orderno" diameter="24" class="action-spinner"></mat-spinner>
						<button
							mat-icon-button
							color="primary"
							(click)="retryExport(item)"
							*ngIf="canRetry(item) && exportingOrderNo !== item.orderno"
							[disabled]="processing || loading || exportingOrderNo"
							matTooltip="Retry export">
							<mat-icon>refresh</mat-icon>
						</button>
						<button
							mat-icon-button
							color="accent"
							(click)="exportOrder(item.orderno)"
							*ngIf="item.export_status === 'pending' && exportingOrderNo !== item.orderno"
							[disabled]="processing || loading || exportingOrderNo"
							matTooltip="Export now">
							<mat-icon>send</mat-icon>
						</button>
						<button
							mat-icon-button
							color="primary"
							(click)="viewLogs(item)"
							*ngIf="item.export_status === 'failed' || item.export_status === 'dead_letter'"
							matTooltip="View logs">
							<mat-icon>article</mat-icon>
						</button>
						<button
							mat-icon-button
							color="primary"
							(click)="viewShipments(item)"
							*ngIf="item.export_status === 'exported'"
							matTooltip="View shipments">
							<mat-icon>local_shipping</mat-icon>
						</button>
						<button
							mat-icon-button
							color="accent"
							(click)="openResponseDetails(item)"
							[disabled]="previewLoadingOrderNo === item.orderno"
							matTooltip="View raw request / response">
							<mat-spinner *ngIf="previewLoadingOrderNo === item.orderno" diameter="20"></mat-spinner>
							<mat-icon *ngIf="previewLoadingOrderNo !== item.orderno">code</mat-icon>
						</button>
						<button
							mat-icon-button
							(click)="archiveQueueItem(item)"
							*ngIf="item.export_status === 'exported' && !item.archived_at"
							matTooltip="Archive (hide from list)">
							<mat-icon>archive</mat-icon>
						</button>
						<button
							mat-icon-button
							color="warn"
							(click)="deleteQueueItem(item)"
							*ngIf="item.export_status === 'failed' || item.export_status === 'pending' || item.export_status === 'dead_letter'"
							[disabled]="processing || loading || exportingOrderNo"
							matTooltip="Remove from queue">
							<mat-icon>delete_outline</mat-icon>
						</button>
					</div>
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
			<tr class="mat-row" *matNoDataRow>
				<td class="mat-cell text-center text-muted py-4" [attr.colspan]="displayedColumns.length">No orders in the export queue.</td>
			</tr>
		</table>

		<mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
	</div>

	<div *ngIf="selectedErrorDetails" class="mt-3 error-details-card">
		<div class="d-flex justify-content-between align-items-start">
			<div class="flex-grow-1">
				<div class="alert alert-warning mb-1" *ngIf="selectedErrorDetails.circuitOpen">
					<strong>Circuit breaker open.</strong> The request was not sent to the 3PL. No raw response from their API.
				</div>
				<div class="alert alert-danger mb-1">
					<strong>Error for order {{ selectedErrorItem?.orderno }}:</strong>
					<span *ngIf="selectedErrorDetails.errorCode" class="ml-2 text-monospace">({{ selectedErrorDetails.errorCode }})</span>
					<pre *ngIf="!selectedErrorDetails.circuitOpen && selectedErrorDetails.message" class="error-full-message mb-0 mt-1">{{ selectedErrorDetails.message }}</pre>
					<span *ngIf="selectedErrorDetails.circuitOpen || (!selectedErrorDetails.message && !selectedErrorDetails.errorCode)">{{ selectedErrorDetails.circuitOpen ? 'Request blocked by circuit breaker.' : 'No message.' }}</span>
				</div>
				<div class="small text-muted mb-1">
					<span *ngIf="selectedErrorDetails.canRetry">This error can be retried.</span>
					<span *ngIf="!selectedErrorDetails.canRetry">This error appears unrecoverable. Fix the order or configuration before retrying.</span>
				</div>
				<div class="d-flex align-items-center flex-wrap mt-1 mb-1">
					<button *ngIf="selectedErrorItem && canRetry(selectedErrorItem)" mat-stroked-button color="primary" class="mr-2" (click)="retryExport(selectedErrorItem); clearErrorDetails()">
						<mat-icon>refresh</mat-icon> Retry Export
					</button>
					<button *ngIf="selectedErrorItem?.export_response" mat-stroked-button (click)="openResponseDetails(selectedErrorItem); clearErrorDetails()">
						<mat-icon>code</mat-icon> View raw response
					</button>
				</div>
				<div *ngIf="selectedErrorDetails.response" class="mt-1">
					<strong>Last 3PL response:</strong>
					<pre class="mb-0 p-2 bg-light small error-details-pre">{{ selectedErrorDetails.response | json }}</pre>
				</div>
			</div>
			<button type="button" class="close ml-2" aria-label="Close" (click)="clearErrorDetails()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
	</div>

</div>
